
export const NavbarData =[
    {
        title : "Home",
        path:"/",
    },
    {
        title : "Myorder",
        path:"/order",
    },
]